import { Routes, Route } from "react-router-dom";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Dashboard from "./pages/dashboard/Dashboard";
import UserManagement from "./pages/dashboard/UserManagement";
import ProfileApprovals from "./pages/dashboard/ProfileApprovals";

import PaymentManagement from "./pages/dashboard/PaymentManagement";
import Reports from "./pages/dashboard/Reports";
import Enquiries from "./pages/dashboard/Enquiries";
import DashboardLayout from "./components/DashboardLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminSettings from "./pages/dashboard/AdminSettings";
import AddUser from "./components/AddUser";
import EditProfile from "./components/EditProfile";
import muiTheme from "./Theme/muiTheme";
import { ThemeProvider, CssBaseline } from "@mui/material";

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected Dashboard Routes */}
          <Route
            path="/dashboard"
            element={<ProtectedRoute permissionKey="dashboard" />}
          >
            <Route element={<DashboardLayout />}>
              {/* Default Dashboard */}
              <Route index element={<Dashboard />} />

              {/* Users (Protected once, children inherit) */}
              <Route
                path="users"
                element={<ProtectedRoute permissionKey="user" />}
              >
                <Route index element={<UserManagement />} />
                <Route path="add-user" element={<AddUser />} />
                <Route path="edit-profile" element={<EditProfile />} />
              </Route>

              {/* Enquiries */}
              <Route
                path="enquiries"
                element={<ProtectedRoute permissionKey="enquiries" />}
              >
                <Route index element={<Enquiries />} />
              </Route>

              {/* Approvals */}
              <Route
                path="approvals"
                element={<ProtectedRoute permissionKey="approvals" />}
              >
                <Route index element={<ProfileApprovals />} />
              </Route>

              {/* Payments */}
              <Route
                path="payments"
                element={<ProtectedRoute permissionKey="payments" />}
              >
                <Route index element={<PaymentManagement />} />
              </Route>

              {/* Reports */}
              <Route
                path="reports"
                element={<ProtectedRoute permissionKey="reports" />}
              >
                <Route index element={<Reports />} />
              </Route>

              {/* Settings */}
              <Route
                path="settings"
                element={<ProtectedRoute permissionKey="settings" />}
              >
                <Route index element={<AdminSettings />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
